import { IWorkItem } from '@models/works';

export enum GalleryIDEnum {
  MY_WORKS = 'my-works',
  CABINET = 'cabinet',
}

export interface IGalleryItem {
  id: GalleryIDEnum;
  name: string;
}
export interface IGalleryData extends Record<GalleryIDEnum, Array<IWorkItem>> {}
